import React from "react";
import SariyerSidebar from "../Sidebar/SariyerSidebar";
import SariyerOtherServices from "../ServiceAreas/SariyerServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const SariyerIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        SARIYER HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Sarıyer’in eşsiz doğası ve geniş konut alanları, ev hijyenine verilen önemi daha da
            artırıyor. İstanbul Temizlik Servisi olarak Sarıyer'de halı, koltuk, yorgan, perde ve battaniye
            gibi ev tekstili ürünlerinizi hijyenik bir şekilde temizliyoruz.
          </p>

          <p>
            Halılarınızın dokusuna uygun özel yıkama yöntemleri, koltuklarınız için ise yerinde
            buharlı temizlik çözümleri sunuyoruz. Çocuklu, alerjik ya da evcil hayvanlı
            aileler için antibakteriyel uygulamalar kullanıyoruz.
          </p>

          <p>
            <strong>Hizmet avantajlarımız şunlardır:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Sarıyer genelinde ücretsiz servis (alım ve teslimat)</li>
            <li>Organik temizlik ürünleri</li>
            <li>48 saat içinde teslimat garantisi</li>
            <li>Buharlı koltuk yıkama ve kumaşa özel kimyasal uygulama</li>
            <li>Leke çıkarma garantisi: kahve, mürekkep, yağ vb.</li>
            <li>Perde, yorgan ve battaniye yıkama hizmeti</li>
          </ul>

          <p>
            Zekeriyaköy, Tarabya, Emirgan, Maslak, Bahçeköy gibi Sarıyer'in tüm bölgelerinde aktif
            olarak çalışıyoruz. Mobil araçlarımızla adresinize geliyor ve ürünlerinizi yerinden alıyoruz.
          </p>

          <p>
            Temizlik sonrası ürünleriniz hijyenik ortamda kurutulur, özel ambalajlarla teslim edilir.
            Koltuklarınız ise kumaş yapısına zarar vermeden fırçalanır ve sterilize edilir.
          </p>

          <p>
            Sarıyer’de güvenilir halı ve koltuk yıkama hizmeti için bizimle iletişime geçin.
            Sipariş, fiyat teklifi veya servis saati bilgisi için web sitemizi ziyaret edin.
          </p>

          <SariyerSidebar />
          <SariyerOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default SariyerIntro;
